import { Component, inject, input, InputSignal } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'details-description',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './description.component.html',
  styleUrl: './description.component.scss',
})

export class DetailsDescriptionComponent {
  public translate = inject(TranslateService);
  public description: InputSignal<any> = input.required<any>();
  public fromBottomSheet: InputSignal<any> = input.required<boolean>();
}